module.exports = __webpack_public_path__ + "img/pic_330101_1.9b855efe.jpg";